import { Box, Flex } from "@chakra-ui/react";
import {
  hideGlobalLoading,
  showGlobalLoading,
} from "helper/GlobalLoadingDispatches";
import { useEffect } from "react";
import { useInvoicesStore } from "store/invoiceStore";
import ComplexTable from "./components/ComplexTable";
import { columnsDataComplex } from "./variables/columnsData";

export default function Invoices() {
  const invoices = useInvoicesStore((state) => state.invoices);
  const loading = useInvoicesStore((state) => state.loading);

  useEffect(() => {
    useInvoicesStore.getState().fetchInvoices();
  }, []);

  useEffect(() => {
    if (loading) {
      showGlobalLoading();
    } else {
      hideGlobalLoading();
    }
  }, [loading]);

  return (
    <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
      <Flex background={{ base: "white", md: "gray.50" }}>
        <ComplexTable
          columnsData={columnsDataComplex}
          isLoading={loading}
          tableData={invoices ?? []}
        />
      </Flex>
    </Box>
  );
}
